export enum UserLinksDiscriminator {
  application = 0,
  provider = 1,
}
